import { GuideLine } from "@/app/activity/store/type"
import { Activity, ActivityTypeKey } from "@/types/activity"

import { create } from "zustand"
import { devtools } from "zustand/middleware"

export type ActivityState = {
  activities: Activity[]
  activity?: Activity
  activeIdfActivity?: number
  tempActivity?: Activity
  hoveredActivityId?: number
  activityTypeFilter: string[]
  isUpsertMode?: boolean
  activityGuideLine?: GuideLine
}
export const initialActivityState: ActivityState = {
  activities: [],
  activity: undefined,
  activeIdfActivity: 0,
  tempActivity: undefined,
  hoveredActivityId: undefined,
  activityTypeFilter: Object.values(ActivityTypeKey),
  isUpsertMode: false,
  activityGuideLine: undefined,
}

export type ActivityStateActions = {
  setActivities: (activities: Activity[]) => void
  setActivity: (activity?: Activity) => void
  setActiveIdfActivity: (activeIdfActivity: number) => void
  setTempActivity: (tempActivity?: Activity) => void
  setHoveredActivity: (hoveredActivity?: number) => void
  setActivityTypeFilter: (activityTypeFilter: string[]) => void
  setUpsertMode: (isUpsertMode?: boolean) => void
  setActivityGuideLine: (activityGuideLine?: GuideLine) => void
}

export type ActivityStore = ActivityState & ActivityStateActions

export const createActivityStore = create<ActivityStore>()(
  devtools(
    (set) => ({
      ...initialActivityState,
      setActivities: (activities: Activity[]) => {
        set({ activities }, undefined, "setActivities")
      },
      setActivity: (activity?: Activity) => {
        set({ activity }, undefined, "setActivity")
      },
      setActiveIdfActivity: (activeIdfActivity: number) => {
        set({ activeIdfActivity }, undefined, "setActiveIdfActivity")
      },
      setTempActivity: (tempActivity?: Activity) => {
        set({ tempActivity }, undefined, "setTempActivity")
      },
      setHoveredActivity: (hoveredActivity?: number) => {
        set({ hoveredActivityId: hoveredActivity }, undefined, "setHoveredActivity")
      },
      setActivityTypeFilter: (activityTypeFilter: string[]) => {
        set({ activityTypeFilter }, undefined, "setActivityTypeFilter")
      },
      setUpsertMode: (isUpsertMode?: boolean) => {
        set({ isUpsertMode }, undefined, "setUpsertMode")
      },
      setActivityGuideLine: (activityGuideLine?: GuideLine) => {
        set({ activityGuideLine }, undefined, "setActivityGuideLine")
      },
    }),
    {
      store: "activity",
      enabled: process.env.NODE_ENV !== "production",
    },
  ),
)
